export default {
  LIST(state, data) {
    state.researchAdvisors = data
  },
  GET(state, data) {
    state.researchAdvisor = data
  },
  UPDATE(state, value) {
    state.researchAdvisor = {
      ...value,
    }
  },
  UPDATE_STUDENT(state, value) {
    state.advisorStudent = value
  },
  ADVISOR(state, value) {
    state.advisor = value
  },
  STUDENTS(state, data) {
    state.students = data
  },
  FRESH(state) {
    state.researchAdvisor = {
      user: {
        id: null,
        first_name: null,
        email: null,
        birth_date: null,
        birth_place: null,
        ctzn: null,
        gd: null,
        mid_name: null,
        full_name: null,
        mob_phone_no: null,
        natn: null,
        per_adr: null,
        pport_expr_date: null,
        pport_issue_date: null,
        pport_issue_place: null,
        pport_no: null,
        sur_name: null,
        pin: null,
        tin: null,
        country: null,
        valid: null,
        scientific_title: null,
        scientific_degree: null,
        user_type: null,
      },
      id: null,
      organization: null,
    }
  },
}
